import { useQuery } from "react-query";

import { API_URL } from "../../../../BaseUrlApi/Url";
import API from "@Config/axios";

export const useGetParentDetail = (parentId) => {
  return useQuery(
    ["parentDetail", parentId],
    async () => {
      const response = await API.get(`${API_URL}/admin/parents/${parentId}`);
      return response.data.parent;
    },
    { enabled: !!parentId }
  );
};
